var HomePageType;
(function (HomePageType) {
  HomePageType["SALE"] = "sale";
  HomePageType["RENT"] = "rent";
  HomePageType["SHARE"] = "share";
  HomePageType["NEW_HOMES"] = "new-homes";
  HomePageType["COMMERCIAL_SALE"] = "commercial-sale";
  HomePageType["COMMERCIAL_LEASE"] = "commercial-lease";
  HomePageType["COMMERCIAL_BUSINESS"] = "commercial-business";
})(HomePageType || (HomePageType = {}));
export default HomePageType;